import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_4: R2BReferralBrandEntity = {
  token: "r2b_referral_4",
  type: "r2bReferralBrand",
  name: "Urbanite Outfitters",
  email: "john.doe@example.com",
  website: "gadgetgalaxy.com",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
